<template>
  <div>
    <video
      ref="videoRef"
      muted
      autoplay
      :controls="false"
      class="absolute top-0 left-0 w-full h-full object-cover rounded-xl p-1"
      style="z-index: -1"
    />
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue';

export default {
  name: 'VideoStreamPreview',
  props: {
    deviceId: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const videoRef = ref(null);
    const deviceId = props.deviceId;

    let stream = null;

    const startCamera = async () => {
      try {
        stream = await navigator.mediaDevices.getUserMedia({
          video: { deviceId: { exact: deviceId } },
        });

        if (videoRef.value) {
          videoRef.value.srcObject = stream;
        }
      } catch (error) {
        console.error('Error accessing the camera:', error);
      }
    };

    const stopCamera = () => {
      if (stream) {
        stream.getTracks().forEach((track) => track.stop());
      }
    };

    onMounted(startCamera);
    onUnmounted(stopCamera);

    return {
      videoRef,
    };
  },
};
</script>
